<template>
  <div class="application-form experience-step">
    <Experiences :profile="profile" flat />

    <v-btn :color="themes.candidate.light.primaryActionButton" @click="$emit('input')" block>
      Save
    </v-btn>
    <v-btn :color="themes.candidate.light.muted" @click="$emit('input')" block>
      Skip
    </v-btn>
  </div>
</template>

<script>
import Experiences from '@/components/candidate/profile/edit/experience/Experiences'

export default {
  components: { Experiences },
  props: { profile: { type: Object, required: true } },
}
</script>
